import Container from './MoveToFolderMenu.container';
import MoveToFolderMenu from './MoveToFolderMenu';

export default Container(MoveToFolderMenu);
